"use strict";
/**
 * Do not edit directly
 * This file is automatically generated
 **/
Object.defineProperty(exports, "__esModule", { value: true });
exports.BORDER = void 0;
exports.BORDER = {
    "radius": {
        "xs": 4,
        "sm": 8,
        "md": 12,
        "lg": 16,
        "pill": 1000,
        "circular": "50%"
    },
    "width": {
        "none": 0,
        "hairline": 0.5,
        "thin": 1,
        "thick": 2,
        "heavy": 4
    }
};
